import React, { useEffect, useState } from 'react'
import UsersChatsList from './UsersChatsList'
import UserChatView from './UserChatView'
import { useSearchParams } from 'react-router-dom'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Stories from '../../Pages/smallComponents/Stories'
import DemoUI from './DemoUI'
import Call from '../../Elements/Call'
import axios from 'axios'
import config from '../../../config'
import { connect } from 'react-redux'

const Conversations = ({ authToken }) => {
  const [searchParams, setSearchParams] = useSearchParams({ chatId: '' })
  const [fetchAgain, setFetchAgain] = useState(false)
  const [socket, setSocket] = useState(null)
  const chatId = searchParams.get('chatId')

  useEffect(() => {
    const fbToken = localStorage.getItem('CordovaToken')
    console.log('fbToken', fbToken)
    const saveToken = async () => {
      const headers = { headers: { Authorization: `Bearer ${authToken}` } }
      if (fbToken) {
        try {
          const { data } = await axios.put(
            `${config.devapi}user/firebase`,
            { FirebaseToken: fbToken },
            headers
          )

          console.log(data)
        } catch (error) {
          console.error('Error : ', error)
        }
      }
    }
    saveToken()
  }, [authToken])
  const isDarkMode = document.body.classList.contains('dark-mode-active')
  return (
    <>
      <div
        className="container-fiuld d-flex justify-content-center align-items-center"
        style={{ height: '-webkit-fill-available' }}
      >
        <div className="row w-100" style={{ height: '-webkit-fill-available' }}>
          <div
            className={`col-12 ${
              chatId === '' ? '' : 'd-none'
            } d-sm-flex flex-column col-sm-5 col-md-4 col-lg-3 px-0`}
            style={{
              height: '-webkit-fill-available',
              borderRight: '1px solid var(--text-color)',
              backgroundColor: `${isDarkMode}? '#0c1624': '#ededed'`
            }}
          >
            <UsersChatsList fetchAgain={fetchAgain} />
            <Footer />
          </div>
          <div
            className={`col-12 ${
              chatId === '' ? 'd-none' : ''
            } col-sm-7 col-md-8 col-lg-9 px-0 d-flex flex-column chat-view`}
            style={{
              backgroundColor: '#ededed',
              height: '-webkit-fill-available'
            }}
          >
            <UserChatView
              setFetchAgain={setFetchAgain}
              fetchAgain={fetchAgain}
              setSocket={setSocket}
              socket={socket}
            />
            {/* <Calling socket={socket} /> */}
            <Call socket={socket} />
            {/* <Footer /> */}
            {/* <DemoUI /> */}
          </div>
        </div>
      </div>
    </>
  )
}
const mapStateToProps = ({ auth }) => {
  const { authToken } = auth
  return { authToken }
}

export default connect(mapStateToProps)(Conversations)
